import type { Dispatch, SetStateAction } from 'react';

import {
    BACKEND_LIST,
    BACKEND_LIST_LABEL,
    BACKEND_URL_LIST,
    GRAPHQL_API_URL_LIST,
    GRAPHQL_ATTACHMENTS_URL_LIST,
} from '@spacefill/shared/src/constants/Backend';
import { getEnvironmentVariable } from '@spacefill/shared/src/utils/GetEnvVar';
import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';

import { Select } from '../Select';

export const SelectBackend = ({
    backends,
    selectedBackend,
    setSelectedBackend,
}: {
    backends: string[];
    selectedBackend: string;
    setSelectedBackend: Dispatch<SetStateAction<string>>;
}) => {
    const { logout } = useUserContext();

    const FEATURE_TOGGLING_IS_ENABLED = getEnvironmentVariable('featureTogglingEnabled');
    if (!FEATURE_TOGGLING_IS_ENABLED) {
        return null;
    }

    const handleChooseBackend = (value: string) => {
        setSelectedBackend(value);
        if (value === BACKEND_LIST.LOCAL) {
            window.sessionStorage.removeItem('backendUrl');
            window.sessionStorage.removeItem('graphqlApiUrl');
            window.sessionStorage.removeItem('attachmentsUrl');
        } else {
            window.sessionStorage.setItem('backendUrl', BACKEND_URL_LIST[value as keyof typeof BACKEND_URL_LIST]);
            window.sessionStorage.setItem(
                'graphqlApiUrl',
                GRAPHQL_API_URL_LIST[value as keyof typeof GRAPHQL_API_URL_LIST]
            );
            window.sessionStorage.setItem(
                'attachmentsUrl',
                GRAPHQL_ATTACHMENTS_URL_LIST[value as keyof typeof GRAPHQL_ATTACHMENTS_URL_LIST]
            );
        }
        logout();
        window.location.reload();
    };

    return (
        <div
            className='mt-2 flex flex-col gap-0.5 px-1'
            data-component-name='SelectBackend'
        >
            <label className='mr-2 text-xs text-gray-700'>Backend</label>
            <Select
                placeholder='Select Backend'
                options={[
                    ...backends.map((database) => ({
                        id: database,
                        value: database,
                        text: BACKEND_LIST_LABEL[database as keyof typeof BACKEND_LIST_LABEL],
                    })),
                ]}
                value={selectedBackend}
                onChange={handleChooseBackend}
            />
        </div>
    );
};
